import axios from '../../../../Utils/Admin/axios.config'

export const ForgotPasword = async (data) => {    
    var response = axios.post(`auth/forget/`,{"email":data.email}).then(res => {
        return res.data
    }).catch(err => { console.log(err) });
    return response
}